import { render, staticRenderFns } from "./rejustReason.vue?vue&type=template&id=336a3df8&scoped=true"
import script from "./rejustReason.vue?vue&type=script&lang=js"
export * from "./rejustReason.vue?vue&type=script&lang=js"
import style0 from "./rejustReason.vue?vue&type=style&index=0&id=336a3df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a3df8",
  null
  
)

export default component.exports